import React from 'react';
import PropTypes from 'prop-types';
import {Input} from './Input';
import {Colours} from '@learningblocks/shared-components/lib/Colours';

export function RangeSlider(props) {
  const leftPortionColour = props.disabled
    ? Colours.colorPrimaryTone40
    : Colours.colorPrimary;

  const onChange = (frame) => {
    !props.disabled && props.onChangeFrame(frame);
  };

  return (
    <Input
      min={props.min}
      max={props.max}
      value={props.currentFrame}
      inputLabel={props.ariaLabel}
      onChange={onChange}
      customThumb={true}
      leftPortionColour={leftPortionColour}
      disabled={props.disabled}
      tabIndex={props.tabIndex}
    />
  );
}

RangeSlider.propTypes = {
  /**
   * min value of range slider
   */
  min: PropTypes.number,
  /**
   * max value of range slider
   */
  max: PropTypes.number,
  /**
   * callback function to trigger on change of input
   */
  onSliderChange: PropTypes.func,
  /**
   * current value of range slider
   */
  value: PropTypes.number,
  /**
   * CurrentFrame stores the data of the animation shows at the moment
   */
  currentFrame: PropTypes.number,
  /**
   * Used to display the arialabel of the content
   */
  ariaLabel: PropTypes.string,
  /**
   * Disabled is a boolen which stores the component is working or not
   */
  disabled: PropTypes.bool,
  /**
   * Which is used for keyboard navigation
   */
  tabIndex: PropTypes.number,
};
RangeSlider.defaultProps = {
  value: 0,
  min: 0,
  max: 100,
  invalid: true,
};
